import * as React from "react";
import BackGround from "../features/components/BackGround";
import TopPage from "../features/top/TopPage";
import GeneratePage from "../features/generate/GeneratePage";
import ReviewPage from "../features/review/ReviewPage";
import ModalProvider from "../../provider/ModalProvider";
import ReviewProvider from "../../provider/ReviewProvider";
import DialogProvider from "../../provider/DialogProvider";

const App: React.FC = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  console.log(API_URL, "API_URL");

  return (
    <ModalProvider>
      <DialogProvider>
        <BackGround>
          <TopPage />
          <GeneratePage />
          <ReviewProvider>
            <ReviewPage />
          </ReviewProvider>
        </BackGround>
      </DialogProvider>
    </ModalProvider>
  );
};

export default App;
